<clr-modal [clrModalOpen]="modalOpen()" (clrModalOpenChange)="modalOpen.set($event)" [clrModalSize]="'xl'">
  <div class="modal-title">
    <div class="clr-row">
      <div class="clr-col-10" style="text-align: left">
        <h3>
          <span>
            {{ currentThumb()?.title | mrTranslate }} - {{ 'Medien' | mrTranslate }} ({{ currentIndex() + 1 }} /
            {{ previewThumbnails().length }})
          </span>
        </h3>
      </div>
      <div class="clr-col-1">
        @if (isDeleteAllowed()) {
          <button
            type="button"
            class="btn btn-icon"
            style="margin-top: -5px"
            [attr.aria-label]="'löschen' | mrTranslate"
            (click)="deleteItem()">
            <cds-icon shape="times-circle" />
          </button>
        }
      </div>
    </div>
  </div>
  <div class="modal-body">
    <div class="text-center d-f" style="height: min(50svh, 50vw)">
      <ng-container
        *ngTemplateOutlet="
          currentThumb()?.name.includes('.pdf') ? pdf
          : currentThumb()?.plays ? video
          : image
        "></ng-container>
      <ng-template #image>
        <pinch-zoom [limit-zoom]="10" class="h-100 w-100-p" style="background-color: transparent">
          <img [src]="currentThumb()?.src" alt="" class="centred" [class.invertWhenDark]="isSkizze()" />
        </pinch-zoom>
      </ng-template>
      <ng-template #video>
        @if (loadingFile()) {
          <clr-spinner class="centred" />
        } @else {
          <video
            class="mw-100p h-100 centred"
            controls
            autoplay
            [muted]="true"
            [src]="currentThumb()?.url"
            type="video/mp4">
            Your Browser does not support HTML5 Video Playback
          </video>
        }
      </ng-template>
      <ng-template #pdf>
        <a class="titleFile" (click)="openPdfDoc(currentIndex())">
          <br />
          {{ currentThumb()?.name ?? ('Öffnen' | mrTranslate) }}
        </a>
      </ng-template>
    </div>
    @if (previewThumbnails().length > 1) {
      <div class="buttonRow">
        <button type="button" class="btn btn-icon" aria-label="back" (click)="moveGallery('left')">
          <cds-icon shape="angle" direction="left" />
        </button>
        <button type="button" class="btn btn-icon" aria-label="forward" (click)="moveGallery('right')">
          <cds-icon shape="angle" direction="right" />
        </button>
      </div>
    }
    @if (previewThumbnails().length) {
      <div class="thumbnailRow mw-100p scroll-y">
        @for (thumb of previewThumbnails(); track $index) {
          <img
            class="cursor-pointer"
            [src]="thumb.src"
            (click)="changeIndexTo($index)"
            [ngStyle]="{ border: currentThumb() == thumb ? '1px solid black' : 'none' }"
            style="max-height: 50px"
            [class.invertWhenDark]="isSkizze()" />
        }
      </div>
    }
  </div>
</clr-modal>
